module.exports = __webpack_public_path__ + "img/product2880p11.1e3fd629.png";